// extracted by mini-css-extract-plugin
export var kg = "catalogue-module--kg--d2YWf";
export var productCard = "catalogue-module--product-card--xZGyW";
export var productGrid = "catalogue-module--product-grid--kwtmN";
export var products = "catalogue-module--products--BWVkA";